export const FolderIcon: React.FC<{ color?: string; size?: number }> = ({
  color,
  size,
}) => (
  <svg
    width={size || 11}
    height={size || 11}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color || "#1D1C1C"}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 7h6l2 2h10v9a1 1 0 01-1 1H4a1 1 0 01-1-1z" />
  </svg>
);
